import store from '@/store'
import { LANG_CODE_MAP, LANG_NAME_MAP } from '@/class/cargo/model/parameters/LanguageConstant'

/**
 * 根据语言选择对应的值返回
 * @param {*} zhValue
 * @param {*} enValue
 * @param {*} jaValue
 * @param ruValue
 */
export function selectByLang(zhValue, enValue, jaValue, ruValue = undefined, viValue = undefined, thValue = undefined) {
  if (store.getters.language === 'zh') {
    return zhValue
  } else {
    if (typeof jaValue !== 'undefined') {
      if (store.getters.language === 'ja') {
        return jaValue
      }
    }
    if (typeof ruValue !== 'undefined') {
      if (store.getters.language === 'ru') {
        return ruValue
      }
    }
    if (typeof viValue !== 'undefined') {
      if (store.getters.language === 'vi') {
        return viValue
      }
    }
    if (typeof thValue !== 'undefined') {
      if (store.getters.language === 'th') {
        return thValue
      }
    }
    return enValue
  }
}

/**
 * 获取对应的国际化列值（chineseName/englishName、zhName/enName）
 * @param {*} obj
 * @returns
 */
export function getLangColumn(obj) {
  if (store.getters.language === 'zh') {
    if (obj.hasOwnProperty('chineseName')) {
      return obj.chineseName
    } else if (obj.hasOwnProperty('zhName')) {
      return obj.zhName
    }
  } else {
    if (obj.hasOwnProperty('englishName')) {
      return obj.englishName
    } else if (obj.hasOwnProperty('enName')) {
      return obj.enName
    }
  }
  return undefined
}

/**
 * 获取对应的国际化路由信息标题（title/enTitle/jaTitle）
 * @param {*} meta
 * @returns
 */
export function getLangMetaTitle(meta) {
  if (store.getters.language === 'zh') {
    return meta.title
  } else if (store.getters.language === 'ja') {
    return meta.jaTitle || meta.enTitle
  } else if (store.getters.language === 'ru') {
    return meta.ruTitle || meta.enTitle
  } else if (store.getters.language === 'th') {
    return meta.thTitle || meta.enTitle
  } else if (store.getters.language === 'vi') {
    return meta.viTitle || meta.enTitle
  } else {
    return meta.enTitle
  }
}

/**
 * 根据languageList获取本地化名称，用于UI自定义表单
 * @param {Object} data 包含languageList的对象
 * @returns {string} 本地化后的名称
 */
export function getLocalizedName(data, fieldName = 'languageList') {
  if (!data[fieldName]) return data.name
  const currentLang = LANG_CODE_MAP[store.getters.language] || 'zh_CN'
  const langItem = data[fieldName].find(item => item.language === currentLang)
  return langItem ? langItem.name : data.name
}

/**
 * 获取当前语言的语言代码
 * @returns {string} 当前语言代码
 */
export function getCurrentLangCode() {
  return LANG_CODE_MAP[store.getters.language] || 'zh_CN'
}

/**
 * 获取语言名称
 * @param {string} langCode 语言代码
 * @returns {string} 语言名称
 */
export function getLangName(langCode) {
  return LANG_NAME_MAP[langCode] || '中文'
}
